const ShowHepExercises = ({ name, description, details, video }) => {


	return (
		<>
			<div className="row mb-1 mt-5">
				<div className="col-md-12" style={{ 'fontWeight': '600', 'fontSize': 'large' }}>{name}</div>
			</div>
			<div className="row mb-1">
				<div className="col-md-12"><h6>{details}</h6></div>
			</div>
			<div className="row mb-1">
				<div className="col-md-12"><h6>{description}</h6></div>
			</div>
			{(video) &&
				<div className="row mb-1">
					<div className="col-md-12 text-steel"><h6><strong><a target = '_blank' rel="noreferrer" href={video}>Show Video</a></strong></h6></div>
				</div>
			}
		</>
	)
}

export default ShowHepExercises